import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { rgba } from 'polished';
import type { HeaderCellGroup } from '../types';
import Sort from './Sort';
import { InfoButton } from '../../../global';
import { Tooltip } from '../../index';
import classNames from 'classnames';

interface Props {
  /**
   * react-table column props.
   */
  column: HeaderCellGroup;
  /**
   * Truncate title
   */
  truncate?: boolean;
  /**
   * Cell content.
   */
  children: string | React.ReactNode;
}

const HeaderCell = ({ column, truncate = false, children } : Props): JSX.Element => (
  <div
    {...column.getSortByToggleProps()}
    className={`flex whitespace-nowrap items-center justify-items-center ${classNames({ 'truncate': truncate })}`}
    title={(column.canSort && !column.tooltipMessage) ? (column.title ?? `Sort by ${column.id}`) : undefined}
  >
    <GlobalStyle/>
    {children}
    <div className={'flex justify-items-center'}>
      {column.tooltipMessage && (
        <Tooltip
          tooltipMessage={column.tooltipMessage}
          arrow={false}
          placement={'right-start'}
          theme={'whizz'}
        >
          <span>
            <InfoButton/>
          </span>
        </Tooltip>
      )}
      {column.canSort && (
        <Sort column={column} />
      )}
    </div>
  </div>
);

const GlobalStyle = createGlobalStyle`
  .tippy-box[data-theme~='whizz'] {
    background-color: ${rgba(255, 250, 235, 1)};
    border: 1px solid ${rgba(229, 225, 211, 1)};
    font-style: italic;
    color: #37374b;
    border-radius: 10px;
    box-shadow: 3px 4px 8px -2px ${rgba(0, 8, 16, 0.5)};
    padding: 10px
  }
`;

HeaderCell.displayName = 'HeaderCell';

export default HeaderCell;
